import React, {Suspense} from 'react'
import {connect, Provider} from 'react-redux'
import Cookies from "js-cookie";
import {Redirect, Route, Switch} from 'react-router-dom'
import {BEARER_NAME} from "~/config/constants";
import {LOGIN, INVOICE_LIST, INVOICE_CREATE} from "~/router/routes";
import {HeaderContainer} from '@components/layout/header/header.container';
import {SidebarContainer} from '@components/layout/sidebar/sidebar.container';
import PageTitleComponent from "../components/page-title.component";
import CompanyLockPageComponent from '@components/layout/company-lock-page/company-lock-page.component'
import {ToastContainer} from "react-toastify";
import {fb} from '~/utils/marketing/fb';
import ModalWindowManager from '@components/layout/modals/manager/modal-window-manager.container';
import SocketModalManager from '@components/layout/socket-modal/manager/socket-modal.container';
import NotFoundPageComponent from '@components/layout/not-foung-page/not-foung-page.component.js';
import { withStyles } from '@material-ui/core/styles';
import {getLazyComponent, privateMappings} from '~/router/mapping';
// import PreloaderContainer from '@components/layout/preloader/preloader.component';
import FallbackContainer from '@components/layout/preloader/fallback.component';
import PreloaderContainer from '@components/layout/preloader/preloader.component';
import { withRouter } from "react-router-dom";

const mapStateToProps = (state) => ({
    isAuthenticated: !!Cookies.get(BEARER_NAME),
    email: state.context.user.email,
    UiUxSidebarAndHeader: state.context.featureFlags.UiUxSidebarAndHeader || false,
    daysLeft: state.context.company.daysLeft,
});

const styles = (theme) => {
    return ({
        component: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            width: '100%',
            ...setComponentMargin(theme),
        },
    })
};

const setComponentMargin = (theme) => {
    let componentMargin = {};
    for (let mixin in theme.mixins.toolbar) {
        theme.mixins.toolbar[mixin].minHeight
            ? componentMargin[mixin] = {marginTop: `${theme.mixins.toolbar[mixin].minHeight}px`}
            : componentMargin['marginTop'] = `${theme.mixins.toolbar[mixin]}px`
    }
    return componentMargin;
}

export const PrivateRouteV2 = connect(mapStateToProps)(withRouter(withStyles(styles)(React.memo(({
  isAuthenticated,
  email,
  UiUxSidebarAndHeader,
  daysLeft,
  classes,
  ...rest
}) => {
    return <>
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            // draggable
            pauseOnHover
        />
        { isAuthenticated
            ? <div className={'container'}>
                    { email && fb.init(email) }
                    <PageTitleComponent />
                    <div className={'wrapper'}>
                        <HeaderContainer />
                        <SidebarContainer key={'sidebar'}/>
                        { email ? (
                            <Switch>
                                {Object.keys(privateMappings).map((url) => (
                                    <Route
                                        path={url}
                                        exact={true}
                                        key={url}
                                        component={(props) => {
                                            const LazyComponent = getLazyComponent(url);
                                            return !!LazyComponent
                                                ? <Suspense fallback={<FallbackContainer/>}>
                                                    {daysLeft < 0 && url !== INVOICE_LIST && url !== INVOICE_CREATE
                                                        ? <CompanyLockPageComponent daysLeft={daysLeft}/>
                                                        : (<div className={classes.component} id={'content-wrapper'}>
                                                            <LazyComponent {...props} />
                                                            {/*<PreloaderContainer/>*/}
                                                        </div>)
                                                    }
                                                </Suspense>
                                                : <NotFoundPageComponent />
                                        }}
                                    />
                                ))}
                                <Route
                                    path={"*"}
                                    component={() => (
                                        <Suspense fallback={<PreloaderContainer/>}>
                                            <NotFoundPageComponent/>
                                        </Suspense>
                                    )}
                                />
                            </Switch>
                        ) : undefined }
                    </div>
                    <Suspense fallback={<FallbackContainer/>}>
                        <ModalWindowManager />
                        <SocketModalManager />
                    </Suspense>
                </div>
            : <Redirect
                to={{
                    pathname: LOGIN,
                    state: { redirectPage: rest?.location?.pathname }
                }}
            />
        }
    </>
}, (prevProps, nextProps) => {
    // check location is the same and avoid re-render
    return JSON.stringify({
        ...prevProps.location,
        email: prevProps.email,
        key: ''
    }) == JSON.stringify({
        ...nextProps.location,
        email: nextProps.email,
        key: ''
    })
}))));
